(function () {
    const config = document.querySelector('[data-sc-ads]');
    const content = document.querySelector('.gh-article .gh-content');
    if (!config || !content || config.dataset.initialized) return;
    config.dataset.initialized = 'true';
    const client = config.dataset.client || '';
    if (!/^ca-pub-\d{16}$/.test(client)) return;

    // Exclude controls, code and promotional footers from the length estimate.
    const copy = content.cloneNode(true);
    copy.querySelectorAll('script, style, pre, code, nav, button, .notion-transclusion_reference-block').forEach((node) => node.remove());
    const length = (copy.textContent || '').replace(/\s/g, '').length;
    if (length < 800) return;

    const placements = [];
    function add(slot, anchor, position) {
        if (!/^\d{8,12}$/.test(slot || '') || !anchor) return;
        const box = document.createElement('aside');
        box.className = 'sc-ad gh-canvas';
        box.setAttribute('aria-label', '광고');
        box.dataset.adPosition = position;
        const label = document.createElement('span');
        label.className = 'sc-ad-label';
        label.textContent = '광고';
        const ad = document.createElement('ins');
        ad.className = 'adsbygoogle';
        ad.style.display = 'block';
        ad.dataset.adClient = client;
        ad.dataset.adSlot = slot;
        ad.dataset.adFormat = 'auto';
        ad.dataset.fullWidthResponsive = 'true';
        box.append(label, ad);
        anchor.after(box);
        placements.push(box);
    }

    // Never insert inside download controls, code, tables, lists or closed toggles.
    if (length >= 2000) {
        let read = 0;
        const paragraphs = content.querySelectorAll('p, .notion-text-block');
        for (const paragraph of paragraphs) {
            if (paragraph.closest('aside, nav, details, table, pre, blockquote, li, figure, a, button, .notion-transclusion_reference-block')) continue;
            if (paragraph.querySelector('button, iframe, input, ins, a[download], .notion-file-block')) continue;
            const size = (paragraph.textContent || '').replace(/\s/g, '').length;
            read += size;
            if (read >= 600 && size >= 80 && length - read >= 800) {
                add(config.dataset.bodySlot, paragraph, 'body');
                break;
            }
        }
    }
    add(config.dataset.endSlot, content, 'end');

    function request(box) {
        if (box.dataset.requested || box.getBoundingClientRect().width < 240) return;
        box.dataset.requested = 'true';
        try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (_) {
            // Do not retry or refresh ads automatically; keep the reserved space stable.
            box.dataset.requestFailed = 'true';
        }
    }
    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                request(entry.target);
                if (entry.target.dataset.requested) observer.unobserve(entry.target);
            });
        }, {rootMargin: '300px 0px'});
        placements.forEach((box) => observer.observe(box));
    } else {
        placements.forEach(request);
    }
})();
